export default __webpack_public_path__ + "static/media/is_logo.48e5f445.svg";